import React from 'react';
import TableTitle from '../../components/Table/TableTitle';
import { ConfigItem } from '../models';
import ConfigTableRow from './ConfigTableRow';
import CreateLeaseTable from './CreateLeaseTable';

const configHeaderColumns = [
  { header: 'Configuration', field: 'config', sortable: true },
  { header: 'Options Total', field: 'optionsTotal', sortable: true },
  { header: 'Count', field: 'count', sortable: true },
  { header: 'Inventory', field: 'inventory', sortable: true },
];

interface Props {
  configList: ConfigItem[];
  configQuery: string;
  sortField: string;
  sortAsc: boolean;
  handleSelectConfig: (item: ConfigItem) => Promise<void>;
  handleSort: (field: string) => void;
}

const ConfigTable = ({ configList, configQuery, sortField, sortAsc, handleSelectConfig, handleSort }: Props) => {
  const filteredConfigList = configList.filter(item => {
    if (!configQuery) {
      return true;
    }
    const configSplit = item.config.split(',');
    const querySplit = configQuery.split(',');
    return querySplit.every(q => configSplit.some(c => c.toLowerCase().trim().includes(q.toLowerCase().trim())));
  });

  return (
    <>
      <TableTitle>Available</TableTitle>
      <CreateLeaseTable headerColumns={configHeaderColumns} sortField={sortField} sortAscending={sortAsc} handleSort={handleSort}>
        {filteredConfigList.map(item => {
          return <ConfigTableRow key={item.config} item={item} handleSelectConfig={handleSelectConfig} />;
        })}
      </CreateLeaseTable>
    </>
  );
};

export default ConfigTable;
